import React from "react";

type Props = {
  title: string;
  subtitle: string;
};

const SignInSectionTitle = (props: Props) => {
  return (
    <h1 className="text-4xl font-bold tracking-widest uppercase text-green-500">
      {props.title} <br />{" "}
      <span className="text-2xl text-green-700">{props.subtitle}</span>
    </h1>
  );
};

export default SignInSectionTitle;
